<!--
 * @Author: wangjx
 * @LastEditors: xiaona.wang
 * @Date: 2021-08-09 10:45:58
 * @LastEditTime: 2021-09-06 20:02:48
 * @Description: 编辑用户权限
-->

<template>
  <el-dialog
    v-dialogDrag
    :title="`分配菜单权限(${roleName})`"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :loading.sync="loading"
    top="5vh"
    width="70%"
    class="self-dialog-form"
  >
    <tabs v-model="activeTabName" :props-data="tabList" @tab-click="handleTabClick" />
    <div v-show="activeTabName === 'WEB'" class="tab_warp_pane">
      <menu-tree
        ref="webTree"
        v-loading="loading"
        hide-select-all="true"
        :tree-data="webMenuTree"
        :show-tag-types="true"
        :default-checked-keys="defaultCheckedKeys"
      />
    </div>
    <div v-show="activeTabName === 'APP'" class="tab_warp_pane">
      <menu-tree
        ref="appTree"
        v-loading="loading"
        hide-select-all="true"
        :tree-data="appMenuTree"
        :show-tag-types="true"
        :default-checked-keys="defaultCheckedKeys"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading.sync="dialogLoading" @click="handleConfirm">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import MenuTree from "@/components/private/menu-tree/menu-tree.vue";
import Tabs from "@/components/common/Tabs/tabs";
import role_api from "@/api/role/role";
import { checkPermission } from "@/utils/permission"; // 权限判断函数

export default {
  name: "AssignMenu",
  components: { MenuTree, Tabs },

  props: {
    visible: {
      type: Boolean,
      default: () => false
    },

    roleId: {
      type: String,
      default: () => ""
    },
    roleName: {
      type: String,
      default: () => ""
    },
    webMenuTree: {
      type: Array,
      default: () => []
    },

    appMenuTree: {
      type: Array,
      default: () => []
    },
    parentNodes: {
      type: Array,
      default: () => []
    },
    datadata: {
      type: Boolean,
      default: false
    },
    showTags: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkedAll: false,
      indeterminate: false,
      treeData: [],
      loading: false,
      childCount: 0,
      nodeCount: 0,
      // 默认选择的菜单
      defaultCheckedKeys: [],

      activeTabName: "WEB",
      tabList: [
        {
          name: "WEB",
          label: "WEB端功能权限"
        },
        {
          name: "APP",
          label: "APP端功能权限"
        }
      ]
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    dialogLoading: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit("update:loading", val);
      }
    }
  },
  watch: {},
  mounted() {
    this.getMenuByRoleId(this.roleId);
  },
  methods: {
    checkPermission,

    /**
     * @description: 获取分配的菜单，返回的数据中父的菜单，需要过滤掉，否则el-tree会现在他所有的字菜单
     * @param {*} roleId
     * @return {*}
     */
    getMenuByRoleId(roleId) {
      this.loading = true;
      role_api.getMenuByRoleId(roleId).then(res => {
        this.loading = false;
        const tempArray = JSON.parse(JSON.stringify(res.data.menuIds));
        this.defaultCheckedKeys = tempArray;
      });
    },

    /**
     * @description: 确定
     * @param {*}
     * @return {*}
     */
    handleConfirm() {
      const menuIds = this.$refs.webTree.getCheckedKeys();
      const menuIds2 = this.$refs.webTree.getHalfCheckedKeys();

      const appMenuIds = this.$refs.appTree.getCheckedKeys();
      const appMenuIds2 = this.$refs.appTree.getHalfCheckedKeys();

      const params = [...menuIds, ...menuIds2, ...appMenuIds, ...appMenuIds2];
      this.loading = true;
      role_api
        .saveCustomRole(this.roleId, params)
        .then(res => {
          this.loading = false;
          this.$message.closeAll();
          this.$message.success("操作成功");
          this.dialogVisible = false;
        })
        .catch(() => {
          this.loading = false;
          this.$message.closeAll();
          this.$message.error("操作失败");
        });
    },

    /**
     * @description: web、app切换
     * @param {*} tab
     * @param {*} event
     * @return {*}
     */
    handleTabClick(tab, event) {
      /*
       * const checkChange = this.$refs.webTree.getCheckChange();
       * console.log(checkChange);
       */

      this.activeTabName = tab.name;
    }
  }
};
</script>

<style lang="scss">
// .custom-theme .self-dialog-form .el-dialog__body{
//   overflow-y: hidden!important;;
// }
// $border-color__ccc: #ccc;
// ul,
// li {
//   list-style: none;
//   padding: 0;
//   margin: 0;
// }
// .role--table--head {
//   ul {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     border: 1px solid $border-color__ccc;
//     height: 40px;
//     line-height: 40px;
//     background-color: #eaedf3;
//     text-align: center;
//     li:nth-child(1) {
//       flex: 1;
//     }
//     li:nth-child(2) {
//       border-left: 1px solid $border-color__ccc;
//       width: 200px;
//     }
//   }
// }
// .custom-tree-node {
//   flex: 1;
//   min-width: 200px;
//   height: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   font-size: 14px;
//   span:nth-child(2) {
//     display: inline-block;
//     width: 200px;
//     height: calc(100% + 2px);
//     line-height: 40px;
//     border-left: 1px solid $border-color__ccc;
//     text-align: center;
//   }
// }
// ::v-deep .el-tree-node__content {
//   position: relative;
//   width: 100%;
//   line-height: 28px;
//   height: 36px;
//   border: 1px solid $border-color__ccc;
//   border-top: none;
//   &::before {
//     content: "";
//     width: 30px;
//     height: 100%;
//   }
// }
// ::v-deep .el-checkbox {
//   position: absolute;
//   left: 10px;
// }
// ::v-deep .el-tree-node > .el-tree-node__children {
//   overflow: inherit;
// }
// ::v-deep .el-tree__empty-block {
//   border: 1px solid $border-color__ccc;
//   border-top: none;
// }
</style>
